import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

// Protège une route : redirige vers /login si non authentifié, en conservant
// la destination initiale dans location.state.from pour y revenir après connexion.
const RequireAuth = ({ authStatus, children }) => {
    const location = useLocation();

    if (authStatus === 'checking') {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <Spinner animation="border" variant="secondary" />
            </div>
        );
    }

    if (authStatus === 'anon') {
        return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
    }

    return children;
};

export default RequireAuth;
